import * as moment from 'moment';
import { ClonableItem } from './clonable-item';
import { TIME_FORMAT } from '../utils/utils';
import { IProcessesStatistic } from '../interfaces/processes-statistic.interface';

export class ProcessesStatistic extends ClonableItem<IProcessesStatistic> implements IProcessesStatistic {
    processesCount: number;
    runningThreadsCount: number;
    maxThreadsCount: number;
    availableThreadsCount: number;
    activeProcessesCount: number;
    allowedThreadsCount: number;
    threadsUpdateTime: string;
    finishingProcessesCount: number;
    finishingThreadsCount: number;
    alreadyReservedThreadsCount: number;
    availableToReserveThreadsCount: number;
    threadsIncreaseSchedulerActive: boolean;
    processesSchedulerActive: boolean;

    threadsUpdateTimeM: moment.Moment;
    threadsUpdateTimeStr: string;

    constructor(data: IProcessesStatistic) {
        super(data);
        this.threadsUpdateTimeM = this.threadsUpdateTime ? moment(this.threadsUpdateTime) : null;
        this.threadsUpdateTimeStr = this.threadsUpdateTimeM ? this.threadsUpdateTimeM.format(TIME_FORMAT) : '-';
    }
}
